var e=(e,r)=>1!==e.nodeType?[]:Array.from(e.parentElement.children).filter(t=>t!=e&&(!r||t.matches(r)));export{e as default};